import { render, staticRenderFns } from "./business_wall.vue?vue&type=template&id=89a33786&"
import script from "./business_wall.vue?vue&type=script&lang=js&"
export * from "./business_wall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports